import React from 'react';
import PropTypes from 'prop-types';

/**
 * ListCheckbox – Checkbox usado en listados (facilities, locations, users).
 * Mismo aspecto: 18px, borde gris sin marcar, celeste (#61b8e7) con check blanco al marcar.
 */
const CHECKBOX_CLASS =
  'size-[18px] appearance-none bg-white border-2 border-[#9e9e9e] rounded-[3px] cursor-pointer checked:bg-[#61b8e7] checked:border-[#61b8e7] transition-all group-hover:border-[#61b8e7] pointer-events-none';

const ListCheckbox = ({ checked, onToggle, ariaLabel, className = '' }) => (
  <button
    type="button"
    onClick={onToggle}
    className={`group inline-flex p-0 border-0 bg-transparent cursor-pointer ${className}`}
    aria-label={ariaLabel}
    aria-pressed={checked}
  >
    <div className="relative shrink-0">
      <input
        type="checkbox"
        checked={checked}
        readOnly
        className={CHECKBOX_CLASS}
        tabIndex={-1}
        aria-hidden
      />
      {checked && (
        <svg
          className="absolute left-[3px] top-[3px] w-[12px] h-[12px] pointer-events-none"
          fill="none"
          viewBox="0 0 12 10"
        >
          <path
            d="M1.5 5L4.5 8L10.5 1.5"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  </button>
);

ListCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ListCheckbox;
